import React from "react";
import { domToReact } from "html-react-parser";
import { renderToString } from "react-dom/server";
import CollapsibleContent from "../components/CollapsibleContent/CollapsibleContent";
import { createRedirectURL } from "./helperFunctions";
const {
  CLASSES: { COLLAPSIBLE_SECTION },
} = require("./constants");
const contentParserOptions = {
  replace: domNode => {
    if (
      domNode?.attribs?.["data-blocktype"] ===
      "custom-block"
    ) {
      return <></>;
    }
    if (
      domNode &&
      domNode?.attribs?.class ===
        COLLAPSIBLE_SECTION.SECTION
    ) {
      return collapsibleContentParser(domNode);
    }

    if (
      domNode &&
      domNode.name === "a" &&
      domNode.attribs &&
      domNode.attribs.href
    ) {
      if (domNode.attribs.href[0] === "/") {
        domNode.attribs.href = process.env
          .GATSBY_PATH_PREFIX
          ? "/" +
            process.env.GATSBY_PATH_PREFIX +
            createRedirectURL(domNode.attribs.href)
          : createRedirectURL(domNode.attribs.href);
      }
    }
  },
};

export const collapsibleContentParser = domNode => {
  const content = [];
  let heading = "";
  if (domNode?.children) {
    heading =
      domNode?.children?.[0]?.children?.[0]?.children?.[0]
        ?.data;
    content?.push(
      renderToString(
        domToReact(domNode?.children?.[1]?.children)
      )
    );
  }
  let domNodeTemp = domNode?.next;

  while (domNodeTemp) {
    if (domNodeTemp?.data === "\n\n") {
      domNodeTemp = domNodeTemp?.next;
    } else {
      domNodeTemp = null;
    }
  }
  return (
    <CollapsibleContent
      heading={heading}
      content={content}
    />
  );
};

export default contentParserOptions;
